module.exports = __webpack_public_path__ + "static/media/6_screen.59abd106.png";